import React, { useEffect, useState } from "react";
import { CustomTab, CustomTabs } from "../../components/tabs/Tabs";
import SpentFunds from "./tabs/SpentFunds";
import RequestedFunds from "./tabs/RequestedFunds";
import ReceivedFunds from "./tabs/ReceivedFunds";
import { cashConverter } from "../../components/Form";
import useDebounce from "../../hooks/useDebounce";
import { exportCSVAPi, spentFundApi } from "../../services/theFunds";
import {
  catchMessage,
  elseMessage,
  successMessage,
} from "../../comman/Message";
import { PaginationShow } from "../../comman/action/Pagination";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useButtonLoader from "../../hooks/UseButtonLoader";
import { setJwtToken } from "../../config/axiosInstance";
import axios from "axios";
import moment from "moment";

const Funds = () => {
  const fundTab = localStorage.getItem("fundTabs") || "";
  const [type, setType] = useState(fundTab || "spent");
  localStorage.setItem("fundTabs", type);
  const [search, setSearch] = useState("");
  const debounceValue = useDebounce(search || "", 300);
  const [total, setTotal] = useState(0);
  const [pages, setPage] = useState(1);
  const [fundList, setFundList] = useState([]);
  const [fund, setFund] = useState({});
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [buttonref, buttonLoader] = useButtonLoader("Export as CSV");
  const url = `${process.env.REACT_APP_API_URL}/admin/fund/export_fund?fundType=${type}`;
  const date = moment(new Date()).format("DD-MM-YYYY");
  //-----------handle-pagination-----------
  const handlePageChange = (event) => {
    setPage(event);
  };
  //-----------listing-----------------
  const fathSpentFund = async (
    page = pages,
    fundType = type,
    search = debounceValue
  ) => {
    try {
      showLoader();
      setFundList([]);
      const res = await spentFundApi({ page, fundType, search });
      if (res?.data?.status === 200) {
        const data = res?.data?.data;
        setFundList(data?.resources || []);
        setTotal(data?.total);
        setFund(data || {});
      } else {
        elseMessage(res);
        setFundList([]);
      }
    } catch (err) {
      catchMessage(err);
      setFundList([]);
    } finally {
      hideLoader();
    }
  };
  useEffect(() => {
    fathSpentFund(pages, type, debounceValue);
  }, [debounceValue, type, pages]);

  useEffect(() => {
    setSearch("");
  }, [type]);

  //---------------export-csv---------------------
  const downloadFile = async (url, fileName, params = {}) => {
    try {
      buttonLoader(true);
      const { headers } = setJwtToken();
      const response = await axios.get(url, {
        params,
        responseType: "blob",
        headers,
      });

      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } else {
        throw new Error("File download failed");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      if (axios.isCancel(error)) {
        console.log("Request cancelled:", error.message);
      } else {
        console.error("Error:", error.message);
      }
    } finally {
      buttonLoader(false);
    }
  };
  return (
    <div className="WrapperArea">
      {loader}
      <div className="WrapperBox">
        <div className="TitleBox">
          <h4 className="Title">Funds Management</h4>
        </div>
        <div className="row mt-4 d-flex justify-content-center">
          <div className="col-2 fund_card">
            <h4>{cashConverter(fund?.availablefund)}</h4>
            <span>Available fund</span>
          </div>
          <div className="col-2 fund_card">
            <h4>{cashConverter(fund?.totalfundSpent)}</h4>
            <span>Total Spent fund</span>
          </div>
          <div className="col-2 fund_card">
            <h4>{cashConverter(fund?.totalReceivedFund)}</h4>
            <span>Total received fund</span>
          </div>
          <div className="col-2 fund_card">
            <h4>{cashConverter(fund?.totalModifyReceivedFund)}</h4>
            <span>Total Modified received fund</span>
          </div>
        </div>
        <div className="col-sm-12 col-form-label mx-auto mt-5">
          <CustomTabs
            value={type}
            onChange={(e, section) => {
              setType(section);
            }}
            aria-label="Content"
            variant="fullWidth"
          >
            <CustomTab value="spent" label="Spent Funds" />
            <CustomTab value="received" label="Received Funds" />
            <CustomTab value="request" label="Requested Funds" />
          </CustomTabs>
        </div>
        <div className="FilterBox FilterArea justify-content-between">
          <div className="form-group search">
            <input
              type="search"
              className="form-control"
              placeholder={type === "received" ? "Search Username" : "Search"}
              value={search || ""}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <button
            className="btn_size"
            ref={buttonref}
            onClick={() => downloadFile(url, `${type}_${date}`)}
          >
            Export as CSV
          </button>
        </div>
        {type === "spent" && <SpentFunds listing={fundList} page={pages} />}
        {type === "received" && (
          <ReceivedFunds listing={fundList} page={pages} />
        )}
        {type === "request" && (
          <RequestedFunds
            fundList={fundList}
            page={pages}
            listing={fathSpentFund}
          />
        )}
        <PaginationShow
          total={total}
          activePage={pages}
          handlePageChange={handlePageChange}
        />
      </div>
    </div>
  );
};
export default Funds;
